<template>
  <div class="animated fadeIn">
    <b-card>
      <h1
        v-b-toggle.organizations
        class="mb-0 d-flex align-items-center justify-content-between"
      >
        Organizations <i class="icon-arrow-down font-xl" />
      </h1>

      <b-collapse ref="collapse" id="organizations" visible>
        <div class="pt-4">
          <b-input
            v-model="search"
            debounce="500"
            placeholder="search..."
            type="search"
          />
        </div>
        <b-table
          :key="tableKey"
          :fields="[
            { key: 'name', label: 'Name', sortable: true },
            { key: 'members', label: 'Members', sortable: true },
            { key: 'tier', label: 'Tier', sortable: true }
          ]"
          :items="searchOrgs"
          :filter="search"
          :current-page="page"
          :per-page="perPage"
          select-mode="single"
          hover
          selectable
          @row-selected="selectOrg"
        >
          <template #cell(tier)="{ item }">
            {{ item.tier || "-" }}
          </template>
        </b-table>
        <b-pagination
          v-if="total > perPage"
          v-model="page"
          :total-rows="total"
          :per-page="perPage"
          align="center"
          class="mb-4"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />

        <div
          v-if="$store.getters.hasPermission('org.create')"
          class="text-right"
        >
          <b-btn v-b-modal.create-org class="px-4" variant="primary">
            <i class="icon-plus" /> Create Organization
          </b-btn>
        </div>
      </b-collapse>
    </b-card>

    <ManageOrg v-if="selectedOrg" :org-id="selectedOrg.id" @updated="getOrgs" />

    <AdminCreateOrg @created="getOrgs" />
  </div>
</template>

<script>
import API from "@/api";

import AdminCreateOrg from "@/components/organizations/AdminCreateOrg.vue";
import ManageOrg from "@/components/organizations/ManageOrg.vue";

export default {
  components: {
    AdminCreateOrg,
    ManageOrg
  },

  data: () => ({
    page: 1,
    perPage: 10,
    search: "",
    selectedOrg: null,
    tableKey: Date.now().toString(),
    total: 0
  }),

  watch: {
    search() {
      this.page = 1;
    }
  },

  methods: {
    async getOrgs() {
      this.tableKey = Date.now().toString();
    },

    async searchOrgs(ctx) {
      const { success, results } = await API.adminOrgSearch(
        this.search,
        ctx.currentPage,
        ctx.perPage
      );
      if (!success) return;

      this.total = results.total;
      return results.results;
    },

    selectOrg(event) {
      this.selectedOrg = event[0];
      if (this.selectedOrg) {
        setTimeout(() => (this.$refs.collapse.show = false), 100);
      }
    }
  }
};
</script>
